import categoryTypes from './types';

export const initialStates = {
	actives: null,
	subCategories: null,
	dynamicAttributes: null,
	tags: null,
	recommoned_category: null,
};

const categoryReducers = (state = initialStates, action) => {
	switch (action.type) {
		case categoryTypes.ACTIVES.SUCCESS: {
			return { ...state, actives: action?.payload?.data };
		}

		case categoryTypes.ACTIVES.CLEAR: {
			return { ...state, actives: null };
		}

		case categoryTypes.RECOMMONED.SUCCESS: {
			return {
				...state,
				recommoned_category: action?.payload?.data?.attributes,
			};
		}

		case categoryTypes.RECOMMONED.CLEAR: {
			return { ...state, recommoned_category: null };
		}

		case categoryTypes.SUB_CATEGORIES.SUCCESS: {
			return { ...state, subCategories: action?.payload?.data };
		}

		case categoryTypes.SUB_CATEGORIES.CLEAR: {
			return { ...state, subCategories: null };
		}

		case categoryTypes.DYNAMIC_ATTRIBUTES.SUCCESS: {
			return { ...state, dynamicAttributes: action?.payload };
		}

		case categoryTypes.DYNAMIC_ATTRIBUTES.CLEAR: {
			return { ...state, dynamicAttributes: null };
		}

		case categoryTypes.TAGS.SUCCESS: {
			return { ...state, tags: action?.payload?.data };
		}

		case categoryTypes.TAGS.CLEAR: {
			return { ...state, tags: null };
		}

		default:
			return state;
	}
};

export default categoryReducers;
